import { PROFILE } from 'config';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import config from 'devextreme/core/config';
import { Helmet } from 'react-helmet';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { featureFlagActions } from 'store/featureFlagSlice/featureFlagSlice';
import { getCookie } from 'utils/utils';
import { sessionStorageTransferHandler } from './utils/sessionStorageHandlers';
import { licenseKey } from 'devextreme-license';
import * as authSelectors from './store/authSlice/authSelectors';
import { authActions } from './store/authSlice/authSlice';
import MainNavigation from './components/Navigation/MainNavigation';
import AppRoute from 'components/AppRoute/AppRoute';
import useInterceptors from 'hooks/useInterceptors';

const initialPath = window.location.pathname !== '/login' ? window.location.pathname : '/';

config({ licenseKey });

function App() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const user = useSelector(authSelectors.selectUser);
    useInterceptors();

    const removeCookie = () => {
        switch (PROFILE) {
            case 'development':
                document.cookie = 'ssoD=AlertsON; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                break;
            case 'staging':
                document.cookie = 'ssoS=AlertsON; path=/; domain=.birdseyesecurity.com; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                break;
            case 'production':
                document.cookie = 'ssoP=AlertsON; path=/; domain=.birdseyesecurity.com; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                break;
            default:
                document.cookie = 'sso=AlertsON; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        }
    };

    useEffect(() => {
        window.addEventListener('storage', sessionStorageTransferHandler);
        let cookieLasta;
        let cookieSso;
        let cookieAiq;
        let cookieAlert;
        let cookieGu;

        switch (PROFILE) {
            case 'development':
                cookieLasta = getCookie('lastaD');
                cookieSso = getCookie('ssoD');
                cookieAiq = getCookie('aiqD');
                cookieAlert = getCookie('alertD');
                cookieGu = getCookie('guD');
                break;
            case 'staging':
                cookieLasta = getCookie('lastaS');
                cookieSso = getCookie('ssoS');
                cookieAiq = getCookie('aiqS');
                cookieAlert = getCookie('alertS');
                cookieGu = getCookie('guS');
                break;
            case 'production':
                cookieLasta = getCookie('lastaP');
                cookieSso = getCookie('ssoP');
                cookieAiq = getCookie('aiqP');
                cookieAlert = getCookie('alertP');
                cookieGu = getCookie('guP');
                break;
            default:
                cookieLasta = getCookie('lasta');
                cookieSso = getCookie('sso');
                cookieAiq = getCookie('aiq');
                cookieAlert = getCookie('alert');
                cookieGu = getCookie('gu');
        }

        if (cookieSso || cookieAiq || cookieAlert || cookieGu || cookieLasta) {
            // alertService.activate();
            return;
        } else {
            switch (PROFILE) {
                case 'development':
                    document.cookie = 'ssoD=AlertsON; path=/; ';
                    break;
                case 'staging':
                    document.cookie = 'ssoS=AlertsON; path=/; domain=.birdseyesecurity.com; ';
                    break;
                case 'production':
                    document.cookie = 'ssoP=AlertsON; path=/; domain=.birdseyesecurity.com; ';
                    break;
                default:
                    document.cookie = 'sso=AlertsON; path=/; ';
            }
            // alertService.activate();
        }

        window.addEventListener('beforeunload', removeCookie);
        return () => {
            window.removeEventListener('beforeunload', removeCookie);
            // alertService.deactivate();
            window.removeEventListener('storage', sessionStorageTransferHandler);
        };
    }, []);

    useEffect(() => {
        dispatch(featureFlagActions.getFeatureFlagData());
        if (location.pathname === '/login-sso') return;
        dispatch(authActions.getUserData());
    }, [dispatch]);

    useEffect(() => {
        if (user && location.pathname === '/login') {
            navigate(initialPath);
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user, location.pathname]);

    const isUserLoggedIn = !!user;

    return (
        <>
            <Helmet>
                <title>{user ? 'Birdseye' : 'Login | Birdseye'}</title>
            </Helmet>
            {user && <MainNavigation user={user} />}
            <AppRoute user={user} isUserLoggedIn={isUserLoggedIn} />
        </>
    );
}

export default App;
